export default class ShopCart extends HTMLElement {
  open: boolean = false
  cartEl: HTMLElement | null = null
  closeBtnEl: HTMLElement | null = null
  private boundHandleOutsideClick = this.handleOutsideClick.bind(this)

  static get observedAttributes() {
    return ['open']
  }

  constructor() {
    super()

    this.cartEl = this.querySelector<HTMLElement>('aside[data-cart]') as HTMLElement
    this.closeBtnEl = this.querySelector<HTMLElement>('button[data-cart-close]') as HTMLElement

    (window as any).addEventListener('cart:toggle', this.handleCart.bind(this))
    this.closeBtnEl.addEventListener('click', this.handleClick.bind(this))

    document.addEventListener('liquid-ajax-cart:request-end', this.handleCartUpdate.bind(this) as EventListener)
  }

  connectedCallback() {
    console.log('Cart added')
  }
  
  get isOpen() {
    return this.open
  }

  set isOpen(value: boolean) {
    this.open = value
    this.setAttribute('open', value.toString())
    this.toggle()
  }

  handleCart(evt: CustomEvent) {
    // @ts-ignore
    this.isOpen = evt.detail.open
  }

  handleClick(evt: Event) {
    evt.preventDefault()

    window.dispatchEvent(new CustomEvent('cart:toggle', { bubbles: true, detail: { open: false } }))
  }

  toggle() {
    if (this.isOpen) {
      this.cartEl?.classList.add('right-0!')
      // Defer so the click that opened the cart doesn't immediately close it.
      setTimeout(() => {
        document.addEventListener('click', this.boundHandleOutsideClick)
      }, 0)
    } else {
      this.cartEl?.classList.remove('right-0!')
      document.removeEventListener('click', this.boundHandleOutsideClick)
    }
  }

  handleOutsideClick(evt: MouseEvent) {
    const target = evt.target as Node | null
    if (!target || !this.cartEl) return
    if (this.cartEl.contains(target)) return
    window.dispatchEvent(new CustomEvent('cart:toggle', { bubbles: true, detail: { open: false } }))
  }

  handleCartUpdate(evt: CustomEvent) {
    // liquid-ajax-cart v2 fires `liquid-ajax-cart:request-end` with
    // detail = { requestState, cart, previousCart }. The original request
    // type is preserved on requestState.requestType.
    const requestType = evt?.detail?.requestState?.requestType

    if (requestType === 'add') {
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('cart:toggle', { bubbles: true, detail: { open: true } }))
      }, 1000)
    }
  }
}

customElements.define('shop-cart', ShopCart)
